module.exports = __webpack_public_path__ + "img/logo.0fc75c07.png";